var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMobileMessageStroke = function SvgMobileMessageStroke(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 52,
    viewBox: "0 0 40 52",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166626 6.16634C0.166626 2.94468 2.7783 0.333008 5.99996 0.333008H34C37.2216 0.333008 39.8333 2.94468 39.8333 6.16634V45.833C39.8333 49.0547 37.2216 51.6663 34 51.6663H5.99996C2.7783 51.6663 0.166626 49.0547 0.166626 45.833V6.16634ZM5.99996 4.99967C5.35563 4.99967 4.83329 5.52201 4.83329 6.16634V45.833C4.83329 46.4773 5.35563 46.9997 5.99996 46.9997H34C34.6443 46.9997 35.1666 46.4773 35.1666 45.833V6.16634C35.1666 5.52201 34.6443 4.99967 34 4.99967H5.99996Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 44.666C21.933 44.666 23.5 43.099 23.5 41.166C23.5 39.233 21.933 37.666 20 37.666C18.067 37.666 16.5 39.233 16.5 41.166C16.5 43.099 18.067 44.666 20 44.666Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileMessageStroke, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile-message-stroke.0ee47816.svg";
export { ForwardRef as ReactComponent };